import {toggleFoldingBlock} from './folding-block';

const toggleNominationBlock = (node) => {
  node.classList.toggle('is-open');
  const $foldingBlock = node.querySelector('.js-folding-block') || false;
  const $toggleBtn = node.querySelector('.js-nomination-toggle') || false;
  const $buttonText = $toggleBtn.querySelector('span');
  const isNominationBlockOpen = node.classList.contains('is-open');

  if (isNominationBlockOpen) {
    $buttonText.textContent = 'Свернуть';
  } else {
    const $sectionInfo = document.querySelector('#section-info');
    const sectionTopPosition = node.offsetTop + $sectionInfo.offsetTop - 16;
    $buttonText.textContent = $toggleBtn.dataset.text;
    setTimeout(() => {
      window.scroll({
        top: sectionTopPosition,
        left: 0,
        behavior: 'smooth',
      });
    }, 100);
  }

  if ($foldingBlock) {
    const isFoldingBlockOpen = $foldingBlock.classList.contains('is-open');
    if (isFoldingBlockOpen) {
      toggleFoldingBlock($foldingBlock);
    }
  }
};

const changeTab = (tabs, leads, tabIndex) => {
  tabs.forEach((tab, index) => {
    if (index !== tabIndex) {
      tab.classList.remove('is-active');
      leads[index].classList.remove('is-active');
    } else {
      tab.classList.add('is-active');
      leads[index].classList.add('is-active');
    }
  });
};

const addNominationListener = () => {
  document.addEventListener('click', (evt) => {
    const $target = evt.target;
    const $toggleBtn = $target.closest('.js-nomination-toggle') || false;

    if ($toggleBtn) {
      const $nominationBlock = $toggleBtn.closest('.js-nomination') || false;
      toggleNominationBlock($nominationBlock, $toggleBtn);
      $toggleBtn.blur();
    }
  });

  document.addEventListener('change', (evt) => {
    const $target = evt.target;
    const $nominationTabs = $target.closest('.js-nomination-tabs') || false;

    if ($nominationTabs) {
      const $tabs = $nominationTabs.querySelectorAll('.js-tab');
      const $leads = $nominationTabs.querySelectorAll('.js-tab-lead');
      const targetIndex = parseInt($target.dataset.index, 10);
      changeTab($tabs, $leads, targetIndex);
    }
  });
};

export {addNominationListener, toggleNominationBlock};
